export enum MutationType {
  UPDATE_USER_DATA = 'updateUserData',
  UPDATE_SIGNIN_STATUS = 'updateSignInStatus',
  UPDATE_JOB_BADGES = 'updateJobBadges',
  CLEAR_BADGE = 'clearBadge',
  SET_JOB_OWNERSHIP_STATUS = 'setJobOwnershipStatus',
  UPDATE_SELECTED_JOB = 'updateSelectedJob',
  UPDATE_NOT_FOUND_STATUS = 'updateNotFoudRequest',
  SET_IMPERSONATED_BUYER = 'setImpersonatedBuyer',
  SET_LOGGED_IN_AS_ADMIN = 'setLoggedInAsAdmin',
  SET_JOB_DETAILS = 'setHomeDetail',
  SET_MILESTONE_DATA = 'setMilestoneData'
}

export const ActionType = {
  ...MutationType
}

export enum EventType {
  ERROR = 'error',
  LOGOUT = 'logout',
  SIGNIN = 'signedIn',
  RESET_PAGE = 'showResetPage',
  LOGIN_PAGE = 'showLoginPage',
  INFINITE_LOAD = 'infiniteLoad',
  UPDATE_IMAGE_POSITION = 'updatePosition',
  CLOSE_MODAL = 'close',
  VIEW_VERSION = 'isViewVersion',
  CONFIRM_ACTION = 'confirm',
  CANCEL_ACTION = 'cancel',
  OPEN_PRICING_BREAKDOWN = 'openPricingBreakdown',
  SHOW_DETAILS = 'showDetails',
  SHOW_NOTIFICATION_MODAL = 'showNotificationModal',
  TOGGLE_LIGHTBOX = 'toggleLightbox',
  PREVIOUS = 'previous',
  SET_APPOINTMENT_DATE = 'setDate',
  SET_APPOINTMENT_TIME = 'setTime',
  SET_TEAM_MEMBER = 'setTeamMember',
  SELECT_ANY_TEAM_MEMBER = 'selectAny',
  SET_APPOINTMENT_LOCATION = 'setLocation',
  APPOINTMENT_CANCELLED = 'appointmentCancelled',
  APPOINTMENT_DETAILS = 'showAppointmentDetails',
  FETCH_APPOINTMENTS = 'fetchAppointments',
  SET_MESSAGE_RECIPIENTS = 'setMessageRecipients',
  CLOSE_RECIPIENTS_PANEL = 'closePanel',
  REMOVE_RECIPIENT = 'removeRecipient',
  SET_ACTIVE_CONVERSATION = 'setActiveConversation',
  TOGGLE_ATTACHMENT_MODAL_STATE = 'toggleAttachmentsModal',
  TOGGLE_RECIPIENTS_PANEL_STATE = 'toggleRecipientsPanel',
  CLEAR_RECIPIENT_ERROR = 'clearRecipientError',
  SEND_MESSAGE = 'sendMessage',
  DELETE_ALL_FILES = 'deleteAllFiles',
  DELETE_ATTACHMENT = 'deleteAttachment',
  ATTACHMENT_UPLOADED = 'attachmentUploaded',
  FILE_UPLOADED = 'fileUploaded',
  UPLOAD_FAILED = 'uploadFailed',
  REMOVE_FILE = 'removeFile',
  BACK_TO_CONVERSATION = 'backToConversationList',
  UPLOAD_IMAGES = 'uploadImages',
  IMAGE_UPDATED = 'updateImage',
  UPLOAD_INFECTED = 'uploadInfected',
}

export const Phases = {
  Plan: 'Plan',
  Finance: 'Finance',
  Design: 'Design',
  Build: 'Build',
  Own: 'Own'
}

export enum JobStatus {
  PRE_CLOSE = 'pre-close',
  POST_CLOSE = 'post-close'
}

export enum MilestoneStatus {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed'
}

export enum DocumentType {
  PDF = 'pdf',
  OCTETSTREAM = 'octet-stream'
}

export enum TeamGroup {
  MM = 'mm',
  BD = 'bd',
  CC = 'cc',
  DC = 'dc',
  FM = 'fm',
  WR = 'wr'
}

export enum Loader {
  SHOW = 'showLoader',
  HIDE = 'hideLoader'
}

export enum ContactStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum ModalType {
  POPUP_BLOCKER = 'PopupBlockerModal',
  VIEW_VERSION = 'ViewVersionModal',
  DOCUMENT_DOWNLOAD = 'DocumentDownloadModal',
  DOCUMENT_PREVIEW = 'DocumentPreviewModal'
}

export enum progress {
  Plan = 1,
  Finance,
  Design,
  Build,
  Own
}

export enum ToggleStyle {
  plan = 'forPlan',
  finance = 'forFinance',
  design = 'forDesign',
  build = 'forBuild',
  own = 'forOwn'
}

export enum Routes {
  SIGNIN = 'SignIn',
  VERIFY = 'Verification',
  RESET_PASSWORD = 'ResetPassword',
  DASHBOARD = 'Home',
  SELECT_HOME = 'SelectHome',
  PHOTOS = 'MyPhotos',
  DOCUMENTS = 'MyDocuments',
  MY_ACCOUNT = 'MyAccount',
  ERROR = 'SiteError',
  APPOINTMENTS = 'Appointments',
  SCHEDULE_APPOINTMENT = 'Schedule Appointment',
  MODIFY_APPOINTMENT = 'Modify Appointment',
  MESSAGES = 'Messages',
  TEAM_MEMBER_MESSAGE = 'Team member Message'
}

export enum PageTitle {
  SIGNIN = 'Login to My Home',
  VERIFY = 'Verify Password',
  RESET_PASSWORD = 'Reset Password',
  DASHBOARD = 'My Home',
  SELECT_HOME = 'Select My Home',
  PHOTOS = 'My Photos',
  DOCUMENTS = 'My Documents',
  MY_ACCOUNT = 'My Account Information',
  APPOINTMENTS = 'My Appointments',
  SCHEDULE_APPOINTMENT = 'Schedule An Appointment',
  MODIFY_APPOINTMENT = 'Modify Appointment',
  MESSAGES = 'My Messages',
}

export enum BuyerType {
  BUYER = 'BUYER',
  COBUYER = 'COBUYER'
}

export enum StatusCode {
  BADREQUEST = 400,
  UNAUTHORIZED = 401,
  NOTFOUND = 404,
  ISE = 500
}

export enum ApptScheduleSteps {
  SELECT_TEAM_MEMBER = 'SelectTeamMember',
  SELECT_DATE = 'SelectDate',
  SELECT_TIME = 'SelectTime',
  APPOINTMENT_SCHEDULED = 'AppointmentScheduled',
  APPOINTMENT_RESCHEDULED = 'AppointmentReScheduled'
}

export enum DesignMembers {
  DESIGN_CONSULTANT = 'DESIGN CONSULTANT',
  SENIOR_DESIGN_CONSULTANT = 'SENIOR DESIGN CONSULTANT',
  DESIGN_ASSISTANT = 'DESIGN ASSISTANT'
}

export enum UploadStatus {
  PENDING = 'Pending',
  SCANNING = 'Scanning',
  INFECTED = 'Infected',
  UPLOADING = 'Uploading',
  UPLOAD_FAILED = 'Failed',
  COMPLETED = 'Completed',
  REMOVED = 'Removed'
}

export enum MessageSource {
  ADMIN = 'ADMIN',
  PORTAL = 'BUYER',
  EMAIL = 'EMAIL',
  API = 'API',
}
